var QGIV = QGIV || {};

QGIV.ManageFundraisingPageModal = {

    $setManageFundraisingPageModal: $('#manage-fundraising-pages-modal'),

    /**
    * @private
    * @method bind
    * @memberof QGIV.ManageFundraisingPageModal
    * @description Bind event handling functions to the event listener
    */
    bind: function() {
        var _this = this;

        // Note: On initial log in we want the modal to switch profiles to open if there are managed accounts
        if (_this.$setManageFundraisingPageModal && QGIV.showSwitchProfileModal && QGIV.managedProfileLength > 0) {
            _this.$setManageFundraisingPageModal.data('qg_modal').showModal();
        };

        $('.js-switch-dashboard-modal-btn').on('click', function(e) {
            e.preventDefault();

            _this.$setManageFundraisingPageModal.data('qg_modal').showModal();
        });


        // Element styling is dependent on Number of Profiles and screen size
        var isMobileStyle = window.screen.width <= 700;
        if (QGIV.managedProfileLength <= 3 && !isMobileStyle ) {
            $('.switch-managed-modal__mobile').hide();
            $('.switch-managed-modal__btn-container').show();
        } else  {
            $('.switch-managed-modal__btn-container').hide();
            $('.switch-managed-modal__mobile').show();
        }

        // Update ui when new profile is selected,
        // this runs to let user know the choice was selected while waiting for url transition
        $('.switch-btn').on('click', function(e) {
            var loadingModal = $('#loading-modal').modal({
                bgClose : false,
                disableTrigger : true,
                width : 'auto-width'
            });
            if ($(e.currentTarget).hasClass('button-block') ) {
                // Remove Selected Styling from current profile
                $('.switch-managed-modal__btn-container').find('.custom-button-block').addClass('button-block');
                $('.switch-managed-modal__btn-container').find('.custom-button-block').find('.switch-desc').addClass('hide-content');
                $('.switch-managed-modal__btn-container').find('.custom-button-block').find('.switch-icon').addClass('hide-content');
                $('.switch-managed-modal__btn-container').find('.custom-button-block').removeClass('ui-primary-color text-white custom-button-block');
                // Mobile View
                $('.switch-managed-modal__mobile').find('.custom-button-block').addClass('button-block');
                $('.switch-managed-modal__mobile').find('.custom-button-block').find('.switch-desc').addClass('hide-content');
                $('.switch-managed-modal__mobile').find('.custom-button-block').find('.mobile-switch-icon').addClass('hide-content');
                $('.switch-managed-modal__mobile').find('.custom-button-block').removeClass('ui-primary-color text-white custom-button-block');
                // Add selected styling to the profile user is moving to
                $(e.currentTarget).removeClass('button-block');
                $(e.currentTarget).addClass('ui-primary-color text-white custom-button-block');
                $(e.currentTarget).find('.switch-icon').removeClass('hide-content')
                $(e.currentTarget).find('.mobile-switch-icon').removeClass('hide-content')
                $(e.currentTarget).find('.switch-desc').removeClass('hide-content')

                // Tiny time delay to show the selection was made
                setTimeout(function(){
                    // Switch modal for loading modal
                    $('#loading-modal').find('.heading-delta').text('Switching Profiles');
                    loadingModal.data('qg_modal').showModal();
                    $('#manage-fundraising-pages-modal').data('qg_modal').closeModal();
                }, 50);

            } else {
                // No loading modal if they select the same profile they are currently viewing
                $('#manage-fundraising-pages-modal').data('qg_modal').closeModal();
            }
        })
    },

    /**
    * @private
    * @method init
    * @memberof QGIV.ManageFundraisingPageModal
    * @description
    * @param {string} formId
    */
    init: function(formId) {
        var _this = this;
        _this.formId = formId;

        this.bind = this.bind.bind(this);

        var currentProfile = $('#manage-fundraising-pages-modal').data("id")

        // initialize modal
        if ( $.fn.modal ){
            $('#manage-fundraising-pages-modal').modal({
                disableTrigger : true,
                decline : function() {
                    $('#manage-fundraising-pages-modal').data('qg_modal').closeModal();
                },
                onClose: function() {
                    // If the user closes the modal without making a selection (ex. clicking background, X or decline button)
                    // we must still make a network call so the BE can unset the new login flag (showSwitchProfileModal).
                    // If we were to not unset this variable, then the modal would reopen on page change or reload rather than
                    // just initial log in as intended.
                    if ( QGIV.showSwitchProfileModal ) {
                        $.fn.qpost({
                            url : url('switch_managed_profile', [Number(currentProfile)]),
                        });
                    }
                }
            });
        }

        this.bind();
    }
};

$(document).ready(function() {
    var formId = $('#form-id').val();

    QGIV.ManageFundraisingPageModal.init(formId);
});